<template>
  <v-footer
    app
    color="third"
  >
    <v-col class="text-center my-n3 caption" cols="12">
      &copy; {{ new Date().getFullYear() }} made with <v-icon size="15" color="red">mdi-heart</v-icon> by <strong>Faithul Ojebiyi </strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  name: 'bottomfooter'
}
</script>

<style lang="scss" scoped>

</style>
